import React from "react";

export const WalletIcon = ({
  height = "60",
  width = "60",
}: {
  height?: string;
  width?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="60" height="60" rx="30" fill="#D8FB50" />
    <path
      opacity="0.6"
      d="M36.04 31.55C35.62 31.96 35.38 32.55 35.44 33.18C35.53 34.26 36.52 35.05 37.6 35.05H39.5V36.24C39.5 38.31 37.81 40 35.74 40H24.26C22.19 40 20.5 38.31 20.5 36.24V29.51C20.5 27.44 22.19 25.75 24.26 25.75H35.74C37.81 25.75 39.5 27.44 39.5 29.51V30.95H37.48C36.92 30.95 36.41 31.17 36.04 31.55Z"
      fill="#292D32"
    />
    <path
      d="M32.85 21.9501V25.7501H24.26C22.19 25.7501 20.5 27.4401 20.5 29.5101V25.8401C20.5 24.6501 21.23 23.5901 22.34 23.1701L30.28 20.1701C31.52 19.7101 32.85 20.6201 32.85 21.9501Z"
      fill="#292D32"
    />
    <path
      d="M40.5598 31.9699V34.03C40.5598 34.58 40.1198 35.0299 39.5598 35.0499H37.5998C36.5198 35.0499 35.5298 34.2599 35.4398 33.1799C35.3798 32.5499 35.6198 31.9599 36.0398 31.5499C36.4098 31.1699 36.9198 30.95 37.4798 30.95H39.5598C40.1198 30.97 40.5598 31.4199 40.5598 31.9699Z"
      fill="#292D32"
    />
    <path
      d="M32 30.75H25C24.59 30.75 24.25 30.41 24.25 30C24.25 29.59 24.59 29.25 25 29.25H32C32.41 29.25 32.75 29.59 32.75 30C32.75 30.41 32.41 30.75 32 30.75Z"
      fill="#292D32"
    />
  </svg>
);